import {
  TYPE_COLLECTION_FILTER,
  TYPE_NUMERIC_FILTER,
  TYPE_STRING_FILTER,
  TYPE_DATE_TIME_FILTER,
  TYPE_BOOLEAN_FILTER,
  TYPE_TIME_FILTER,
} from '../constants/applied-filter-type';

import {
  EDITOR_TYPE_BUYER_NAME,
  EDITOR_TYPE_RECIPIENT_NAME,
  EDITOR_TYPE_ADDRESS_LINE_1,
  EDITOR_TYPE_ADDRESS_LINE_2,
  EDITOR_TYPE_BUYER_ID,
  EDITOR_TYPE_CITY,
  EDITOR_TYPE_CUSTOM_FIELD_1,
  EDITOR_TYPE_CUSTOM_FIELD_2,
  EDITOR_TYPE_CUSTOM_FIELD_3,
  EDITOR_TYPE_INTERNAL_NOTES,
  EDITOR_TYPE_ITEM_NAME,
  EDITOR_TYPE_ITEM_SKU,
  EDITOR_TYPE_NOTES_TO_BUYER,
  EDITOR_TYPE_NOTES_FROM_BUYER,
  EDITOR_TYPE_ORDER_NUMBER,
  EDITOR_TYPE_POSTAL_CODE,
  EDITOR_TYPE_ORDER_SOURCE,
  EDITOR_TYPE_USPS_ZONE,
  EDITOR_TYPE_ORDER_TAGS,
  EDITOR_TYPE_ADDRESS_VERIFICATION,
  EDITOR_TYPE_ASSIGNED_USER,
  EDITOR_TYPE_LINE_ITEMS,
  EDITOR_TYPE_AMOUNT_PAID,
  EDITOR_TYPE_ORDER_SUBTOTAL,
  EDITOR_TYPE_ORDER_TOTAL,
  EDITOR_TYPE_SHIPPING_PAID,
  EDITOR_TYPE_TAX_PAID,
  EDITOR_TYPE_TOTAL_QUANTITY,
  EDITOR_TYPE_CARRIER,
  EDITOR_TYPE_MARKETPLACE,
  EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED,
  EDITOR_TYPE_STORE,
  EDITOR_TYPE_SHIP_FROM,
  EDITOR_TYPE_DATE_PAID,
  EDITOR_TYPE_SHIP_BY_DATE,
  EDITOR_TYPE_ORDER_DATE,
  EDITOR_TYPE_WAREHOUSE_LOCATION,
  EDITOR_TYPE_SHIP_TO_COUNTRY,
  EDITOR_TYPE_IS_GIFT,
  EDITOR_TYPE_IS_INTERNATIONAL,
  EDITOR_TYPE_RECIPIENT_COMPANY,
  EDITOR_TYPE_STATE,
  EDITOR_TYPE_RESIDENTIAL_INDICATOR,
  EDITOR_TYPE_PACKAGE_TYPE,
  EDITOR_TYPE_SHIPPING_ACCOUNT,
  EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT,
  EDITOR_TYPE_ORDER_WEIGHT,
  EDITOR_TYPE_REQUESTED_SERVICE_MAPPED,
  EDITOR_TYPE_PAYMENT_METHOD,
  EDITOR_TYPE_SELLER_BRAND,
  EDITOR_TYPE_FULFILLMENT_PROVIDER,
  EDITOR_TYPE_DELIVER_BY_DATE,
  EDITOR_TYPE_SHOPIFY_SHIP_FROM,
  EDITOR_TYPE_ORDER_IMPORT_TIME,
} from '../constants/filter-editor-type';

const filterEditorToAppliedFilterTypeMap = {
  [EDITOR_TYPE_BUYER_NAME]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_RECIPIENT_NAME]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ADDRESS_LINE_1]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ADDRESS_LINE_2]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_BUYER_ID]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_CITY]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_CUSTOM_FIELD_1]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_CUSTOM_FIELD_2]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_CUSTOM_FIELD_3]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_INTERNAL_NOTES]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ITEM_NAME]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ITEM_SKU]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_NOTES_TO_BUYER]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_NOTES_FROM_BUYER]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ORDER_NUMBER]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_POSTAL_CODE]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ORDER_SOURCE]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_USPS_ZONE]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_WAREHOUSE_LOCATION]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_RECIPIENT_COMPANY]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ORDER_TAGS]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_ADDRESS_VERIFICATION]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_ASSIGNED_USER]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_LINE_ITEMS]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_AMOUNT_PAID]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_ORDER_SUBTOTAL]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_ORDER_TOTAL]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_SHIPPING_PAID]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_TAX_PAID]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_TOTAL_QUANTITY]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_CARRIER]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_MARKETPLACE]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_STORE]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_SHIP_FROM]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_DATE_PAID]: TYPE_DATE_TIME_FILTER,
  [EDITOR_TYPE_SHIP_BY_DATE]: TYPE_DATE_TIME_FILTER,
  [EDITOR_TYPE_ORDER_DATE]: TYPE_DATE_TIME_FILTER,
  [EDITOR_TYPE_SHIP_TO_COUNTRY]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_IS_GIFT]: TYPE_BOOLEAN_FILTER,
  [EDITOR_TYPE_IS_INTERNATIONAL]: TYPE_BOOLEAN_FILTER,
  [EDITOR_TYPE_STATE]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_RESIDENTIAL_INDICATOR]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_PACKAGE_TYPE]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_SHIPPING_ACCOUNT]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_ORDER_WEIGHT]: TYPE_NUMERIC_FILTER,
  [EDITOR_TYPE_REQUESTED_SERVICE_MAPPED]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_PAYMENT_METHOD]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_SELLER_BRAND]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_FULFILLMENT_PROVIDER]: TYPE_COLLECTION_FILTER,
  [EDITOR_TYPE_DELIVER_BY_DATE]: TYPE_DATE_TIME_FILTER,
  [EDITOR_TYPE_SHOPIFY_SHIP_FROM]: TYPE_STRING_FILTER,
  [EDITOR_TYPE_ORDER_IMPORT_TIME]: TYPE_TIME_FILTER,
};

export const getFilterTypeForEditorType = (editorType) => {
  return filterEditorToAppliedFilterTypeMap[editorType];
};
